



















import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { Category } from "@/typescript/models/categories/types";
export { Category };

@Component
export default class CategoryIconSelectComponent extends Vue {
  @Prop()
  categories!: Array<Category>;

  @Prop()
  value!: number;

  @Prop({
    default: false
  })
  show!: boolean;

  @Emit()
  change(category: Category) {
    return category;
  }

  @Emit()
  toggle(isVisible: boolean) {
    return isVisible;
  }

  @Watch("show")
  onTextChanged(show: boolean) {
    this.showSelectBox = show;
  }

  @Watch("value")
  onValueChanged(value: number) {
    let category = this.categories.find(category => category.id == value);
    if (category) {
      this.selectedIcon = category.icon;
    }
  }

  selectedIcon: string = "";
  showSelectBox: boolean = false;

  changeIcon(category: Category): void {
    this.selectedIcon = category.icon;
    this.toggleShow();
    this.change(category);
  }

  toggleShow(): void {
    const isVisible = !this.showSelectBox;
    this.toggle(isVisible);
    this.showSelectBox = isVisible;
  }
}
